import { Highlight } from "@/components/QuestionCard";

const EM_RE = /\*([^*]+)\*/g;
const REF_RE = /((?:[1-3]\s)?[A-Z][a-z]+\.?\s\d+(?::\d+(?:[-–]\d+)?)?)/g;

function Marked({ text, marks }) {
  if (!marks?.length) return text;
  return text.split(REF_RE).map((seg, k) => (k % 2 === 1 ? <span key={`r${k}-${seg}`}>{seg}</span> : <Highlight key={`t${k}-${seg.length}`} text={seg} terms={marks} />));
}

function Paragraph({ text, marks }) {
  return (
    <p className="qg-reftag text-base leading-relaxed text-muted-foreground">
      {text.split(EM_RE).map((seg, j) =>
        j % 2 === 1 ? <em key={`${j}-${seg.length}`} className="text-foreground/80"><Marked text={seg} marks={marks} /></em> : <span key={`${j}-${seg.length}`}><Marked text={seg} marks={marks} /></span>
      )}
    </p>
  );
}

export default function StudyText({ text, testId, marks }) {
  if (!text) return null;
  return (
    <div className="space-y-4" data-testid={testId}>
      {text.split(/\n\n+/).map((para, i) => (
        <Paragraph key={`${i}-${para.slice(0, 32)}`} text={para} marks={marks} />
      ))}
    </div>
  );
}
